<template>
  <a-modal :width="isMobile ? '100%' : 650" :footer="null" :open="open" @cancel="closeForm">
    <h2>
      Оформление заявки на продукт
    </h2>
    <div>
      <a-form v-if="!showResult" name="createUser" layout="vertical" :model="orderForm" @finish="submitOrderForm">
        <div>
          <div class="form-group-row">
            <a-form-item label="Компания" class="input-form-item"
                         name="company"
            >
              <a-input name="company" v-model:value="orderForm.company" style="min-width: 50%"
                       placeholder="Введите название"/>
            </a-form-item>

            <a-form-item label="Ваше ФИО" class="input-form-item"
                         name="name"
                         :rules="[{ required: true, message: 'Введите имя' }]"
            >
              <a-input name="name" v-model:value="orderForm.name" style="min-width: 50%" placeholder="Введите имя"/>
            </a-form-item>
          </div>

          <div class="form-group-row">
            <a-form-item label="Почта" class="input-form-item" name="email"
                         :rules="[
                          { required: true, message: 'Введите почту' },
                          { type: 'email', message: 'Неверный формат' }]">
              <a-input name="email" v-model:value="orderForm.email" placeholder="example@mail.ru"/>
            </a-form-item>

            <a-form-item label="Номер телефона" class="input-form-item" name="telephone"
                         :rules="[
                           { required: true, message: 'Введите номер телефона' },
                           { pattern: /^(?:\+7|8|7)\d{10}$/, message: 'Неверный формат', trigger: 'change' }]">
              <a-input v-model:value="orderForm.telephone" name="telephone" placeholder="7 (000) 000 00 00"/>
            </a-form-item>
          </div>

          <a-form-item label="Комментарий к заявке" class="input-form-item">
            <a-textarea v-model:value="orderForm.comment" placeholder="Комментарий"/>
          </a-form-item>
        </div>

      <div v-if="quotasLoaded" class="order-list">
        <a-table
            :columns="getExtendedColumns('tests', 'Оценка ЭИ')"
            rowKey="id" :data-source="tableData.tests"
            :table-layout="'fixed'"
            :scroll="{ x: '100%' }"
            :components="getTableComponents('tests')"
            :pagination="false"
            :locale="{ emptyText: emptySlot()}"
        >
          <template #bodyCell="{ column, text, record }">

              <template v-if="column.dataIndex === 'free'">
                <span class="free-quotas">
                  {{ text }}
                </span>
              </template>

              <template v-if="column.dataIndex === 'quota'">
                <a-input-number id="inputNumber" @blur="recalculateTotals('tests')" v-model:value="orderForm.entities.tests[record.product_id]" :min="0" :max="100" :placeholder="'0'" />
              </template>
            </template>
          </a-table>

          <a-table
              :columns="getExtendedColumns('courses', 'Развитие')"
              rowKey="id"
              :data-source="tableData.courses"
              :scroll="{ x: 200 }"
              :components="getTableComponents('courses')"
              :pagination="false"
              :locale="{ emptyText: emptySlot()}"
              :table-layout="'fixed'"
          >
            <template #bodyCell="{ column, text, record }">

              <template v-if="column.dataIndex === 'free'">
                <span class="free-quotas">
                  {{ text }}
                </span>
              </template>

              <template v-if="column.dataIndex === 'quota'">
                <a-input-number class="input-number" id="inputNumber" @blur="recalculateTotals('courses')" v-model:value="orderForm.entities.courses[record.product_id]" :min="0" :max="100" :placeholder="'0'" />
              </template>
            </template>
          </a-table>

          <a-table
              :columns="getExtendedColumns('tools', 'Ежедневные помощники')"
              rowKey="id"
              :data-source="tableData.tools"
              :scroll="{ x: 200 }"
              :components="getTableComponents('tools')"
              :pagination="false"
              :locale="{ emptyText: emptySlot()}"
              :table-layout="'fixed'"
          >
            <template #bodyCell="{ column, text, record }">

              <template v-if="column.dataIndex === 'free'">
                <span class="free-quotas">
                  {{ text }}
                </span>
              </template>

              <template v-if="column.dataIndex === 'quota'">
                <a-input-number id="inputNumber" @blur="recalculateTotals('tools')" v-model:value="orderForm.entities.tools[record.product_id]" :min="0" :max="100" :placeholder="'0'" />
              </template>
            </template>
          </a-table>

          <a-table
              :columns="getShortListColumns('analytics', 'Аналитика')"
              rowKey="id"
              :data-source="tableData.analytics"
              :scroll="{ x: 200 }"
              :components="getTableComponents('analytics')"
              :pagination="false"
              :locale="{ emptyText: emptySlot()}"
              :table-layout="'fixed'"
          >
            <template #bodyCell="{ column, text, record }">

              <template v-if="column.dataIndex === 'free'">
                <span class="free-quotas">
                  {{ text }}
                </span>
              </template>

              <template v-if="column.dataIndex === 'has_access'">
                <a-checkbox v-if="record.has_access"
                            :disabled="true" :checked="true"
                />

                <a-checkbox v-else @change="recalculateTotals('analytics')"
                            :disabled="record.has_access"
                            v-model:checked="orderForm.entities.analytics[record.product_id]"
                />
              </template>
            </template>
          </a-table>
        </div>

        <div class="loading-block" v-else>
          <a-spin />
        </div>

        <a-divider/>

        <div class="button-row">
          <a-col>
            <a-button @click="closeForm" class="secondary-button">Отменить</a-button>
          </a-col>
          <a-col>
            <a-button html-type="submit" :disabled="!totalProductsToOrder" class="primary-button" :loading="isProcessing">Отправить заявку</a-button>
          </a-col>
        </div>
      </a-form>

      <div class="form-successful" v-if="showResult">
        <div class="successful-text">
          <template v-if="successfullySubmitted">
            <SmileOutlined class="happy-smile"/>
            <p>Заявка успешно создана</p>
            <span>Статус заявки можно отслеживать на странице Заказов.</span>
          </template>
        </div>

        <a-divider/>

        <div class="button-row">
          <a-button class="secondary-button" @click="closeForm">Закрыть</a-button>
          <a-button class="secondary-button" @click="() => router.push('/orders')">Перейти в заказы</a-button>
        </div>
      </div>
    </div>
  </a-modal>
</template>

<script>

import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  CloseOutlined,
  ExclamationCircleOutlined,
  FrownOutlined, MinusOutlined,
  PaperClipOutlined,
  PlusOutlined,
  SmileOutlined,
  UploadOutlined
} from "@ant-design/icons-vue";
import {onBeforeMount, reactive, ref, watch} from "@vue/runtime-core";
import {useRouter} from "vue-router";
import {h, onMounted} from "vue";
import NotFoundIcon from "@/assets/images/icons/no_data.svg";
import getReportName from "@/mixins/getReportName";
import {computed} from "@vue/reactivity";
import {useStore} from "vuex";
import {message} from "ant-design-vue";
import toolsTranslate from "@/mixins/dictionaries/toolsTranslate";
import analyticsTranslate from "@/mixins/dictionaries/analyticsTranslate";

export default {
  name: 'new-order-form',
  components: {
    ExclamationCircleOutlined,
    SmileOutlined,
    FrownOutlined,
    PlusOutlined,
    UploadOutlined,
    PaperClipOutlined,
    CheckCircleOutlined,
    CloseCircleOutlined,
    CloseOutlined
  },
  emits: ['close', 'submitted'],
  props: {
    open: Boolean,
  },
  setup(props, context) {

    const router = useRouter();
    const store = useStore();
    const successfullySubmitted = ref(false);
    const isProcessing = ref(false);
    const showResult = ref(false);

    const orderForm = reactive({
      company: '',
      name: '',
      email: '',
      telephone: '',
      user_id: null,
      comment: '',
      entities: {
        tests: {
          total: 0,
        },
        courses: {
          total: 0,
        },
        tools: {
          total: 0,
        },
        analytics: {
          total: 0,
        }
      },
    });

    const submitOrderForm = () => {
      isProcessing.value = true;

      let entities = [];

      Object.entries(orderForm.entities).map(([groupKey, groupObj]) => {
        Object.entries(groupObj)
            .filter(([k]) => k !== "total")
            .map(([productId, count]) => {
              if (!count) {
                return;
              }

              let name = '';
              let productCount = count;

              if (groupKey === 'tests') {
                name = getReportName(productId);
              } else if (groupKey === 'analytics') {
                name = analyticsTranslate[productId];
                productCount = 1;
              } else if (groupKey === 'tools') {
                name = toolsTranslate[productId]
              } else if (groupKey === 'courses') {
                name = Object.values(companyQuotas.value.course_passings.total).find(el => Number(el.course_id) === Number(productId))?.name;
              }

              entities.push({
                id: productId,
                name: name ?? '',
                count: Number(productCount),
                type: groupKey,
              });
            });
      });

      let orderObject = {
        user_id: orderForm.user_id,
        status: "new",
        user_info: {
          name: orderForm.name,
          email: orderForm.email,
          phone: orderForm.telephone,
          company: orderForm.company,
        },
        entities: JSON.stringify(entities),
      }

      store.dispatch('relations/createOrder', orderObject).then(() => {
        showResult.value = true;
        successfullySubmitted.value = true;
        context.emit('submitted');
      }).catch((e) => {
          message.error('Произошла ошибка')
      }).finally(() => {
        isProcessing.value = false;
      });
    }

    const closeForm = () => {
      store.dispatch('relations/clearInsufficientProducts');
      context.emit('close');
    }

    const getTableComponents = (tableKey) => ({
      body: {
        wrapper: (props, {slots}) =>
            h(
                'tbody',
                {
                  ...props,
                  style: {
                    ...(props.style || {}),
                    display: collapsedMap.value[tableKey] ? '' : 'none',
                  },
                },
                slots.default?.()
            ),
      },
    });

    const getExtendedColumns = (key, mainTitle) => {
      return [
        {
          title: () => renderCollapseElement(key),
          dataIndex: 'toggle',
          key: 'toggle',
          width: 20,
          align: 'center',
        },
        {
          title: mainTitle,
          dataIndex: 'product',
          key: 'product',
          width: 180,
          align: 'left',
        },
        {
          title: 'Доступно',
          dataIndex: 'free',
          key: 'free',
          width: 60,
          align: 'right',
        },
        {
          title: renderSpecialHeader(key),
          dataIndex: 'quota',
          key: 'quota',
          width: 80,
          align: 'right',
        },
      ];
    }

    const getShortListColumns = (key, mainTitle) => {
      return [
        {
          title: () => renderCollapseElement(key),
          dataIndex: 'toggle',
          key: 'toggle',
          width: 20,
          align: 'center',
        },
        {
          title: mainTitle,
          dataIndex: 'product',
          key: 'product',
          width: 240,
          align: 'left',
        },
        {
          title: renderSpecialHeader(key),
          dataIndex: 'has_access',
          key: 'has_access',
          width: 80,
          align: 'right',
        },
      ];
    }

    const emptySlot = () =>
        h('div', {class: 'no-data-wrapper'}, [
          h('img', {src: NotFoundIcon, class: 'no-data-image'}),
          h('div', {class: 'no-data-text'}, 'Нет данных для отображения'),
        ]);

    const collapsedMap = ref({
      tests: true,
      courses: true,
      tools: true,
      analytics: true,
    });

    const activeKeys = ref(['tests', 'courses']);

    const renderCollapseElement = (key) =>
        h(
            "span",
            {
              class: [
                "custom-collapse-expand-icon",
                collapsedMap.value[key] ? "custom-collapse-expand-icon--active" : "",
              ],
              onClick: (e) => {
                e.stopPropagation();
                collapsedMap.value[key] = !collapsedMap.value[key];
              },
            },
            [
              h(collapsedMap.value[key] ? MinusOutlined : PlusOutlined, {
                key: collapsedMap.value[key] ? "minus" : "plus",
              }),
            ]
        );

    const renderSpecialHeader = (key) =>
        h('span',
            {
              class: ['selected-quotas'],
            },
            orderForm.entities[key].total,
        )

    const tableData = reactive({
      tests: [],
      courses: [],
      tools: [
        {
          product: toolsTranslate['diary'],
          product_id: 'diary',
          free: 0,
          quota: 0,
        },
        {
          product: toolsTranslate['tracker'],
          product_id: 'tracker',
          free: 0,
          quota: 0,
        }
      ],
      analytics: [],
    });

    const companyQuotas = computed(() => store.state.company.userQuotas);
    const insufficientQuotas = computed(() => store.state.relations.insufficientProducts);
    const profile = computed(() => store.state.profile.profile);
    const totalProductsToOrder = ref(0);

    const quotasLoaded = ref(true);

    onBeforeMount(() => {
      quotasLoaded.value = false;

      store.dispatch('company/getUserQuotas').then(() => {
        prepareData();
        quotasLoaded.value = true;
      });
    });

    const prepareData = () => {
      tableData.tests = Object.entries(companyQuotas.value.test_passings)
          .filter(([key]) => key !== 'empty')
          .map(([key, value]) => {

            let quotasToAppend = calculateQuotasToAppend('tests', key);

            if (quotasToAppend) {
              orderForm.entities.tests[key] = quotasToAppend;
            }

            return {
              product: getReportName(key),
              product_id: key,
              free: value.free,
              quota: quotasToAppend,
            }
          });

      tableData.courses = Object.entries(companyQuotas.value.course_passings.total).map(([key, value]) => {
        let freePassings = companyQuotas.value.course_passings.free.find((course) => course.course_id === value.course_id);

        let quotasToAppend = calculateQuotasToAppend('courses', value.course_id);

        if (quotasToAppend) {
          orderForm.entities.courses[value.course_id] = quotasToAppend;
        }

        return {
          product: value.name,
          product_id: value.course_id,
          free: freePassings?.count ?? 0,
          quota: quotasToAppend,
        }
      });

      companyQuotas.value.instruments?.allowed_instruments?.forEach((instrument) => {
        const quotasToAppend = calculateQuotasToAppend('tools', instrument);

        if (quotasToAppend) {
          orderForm.entities.tools[instrument] = quotasToAppend;
        }

        tableData.tools = tableData.tools.map((row) =>
            row.product_id === instrument
                ? { ...row, quota: quotasToAppend }
                : row
        );
      });

      tableData.analytics = [
        {
          product: 'Эталонный профиль',
          product_id: 'reference_profile',
          has_access: !!companyQuotas.value?.reference_profiles?.free_count ?? 0,
          validUntil: '',
          timeRemaining: null,
        },
        {
          product: 'Отраслевой профиль',
          product_id: 'profile_1',
          has_access: false,
        },
        {
          product: 'ЭИ-профиль команды',
          product_id: 'profile_2',
          has_access: false,
        },
        {
          product: 'ЭИ-профиль подразделения / направления / компании',
          product_id: 'profile_3',
          has_access: false,
        }
      ];

      checkAnalyticsQuotaToAppend();

      recalculateTotals('tests');
      recalculateTotals('courses');
      recalculateTotals('tools');
      recalculateTotals('analytics');
    }

    const calculateQuotasToAppend = (type, product) => {
      let quotasToOrder = 0;

      if (insufficientQuotas.value) {
        let group = insufficientQuotas.value[type];

        if (group) {
          let insufficientProduct = group.find((el) => el.product_id === product);
          quotasToOrder = insufficientProduct ? insufficientProduct.count : 0;
        }
      }

      return quotasToOrder;
    }

    const checkAnalyticsQuotaToAppend = () => {
      tableData.analytics.forEach((el) => {
        let group = insufficientQuotas.value.analytics ?? [];
        let insufficientProduct = group.find((inProduct) => inProduct.product_id === el.product_id);

        if (insufficientProduct) {
          orderForm.entities.analytics[el.product_id] = true;
        }
      });
    }

    const recalculateTotals = (key) => {
      let entity = orderForm.entities[key];

      if (key === 'analytics') {
        orderForm.entities[key].total = Object.entries(entity)
            .filter(([key, v]) => key !== "total" && v)?.length ?? 0
      } else {
        orderForm.entities[key].total = Object.entries(entity)
            .filter(([key]) => key !== "total")
            .reduce((sum, [key, v]) => sum + (Number(v) || 0), 0);
      }

      calculateTotalProducts();
    }

    const calculateTotalProducts = () => {
      totalProductsToOrder.value = orderForm.entities.courses.total +
          orderForm.entities.tests.total +
          orderForm.entities.analytics.total +
          orderForm.entities.tools.total;
    }

    watch(() => profile.value, () => {
        orderForm.name = (profile.value?.first_name + ' ' + (profile.value?.last_name ?? '')) ?? '';
        orderForm.email = profile.value?.email ?? '';
        orderForm.company = profile.value?.company ? profile.value?.company.name : '';
        orderForm.user_id = profile.value?.id ?? '';
    }, { immediate: true });

    const isMobile = ref(window.innerWidth <= 768)

    const onResize = () => {
      isMobile.value = window.innerWidth <= 768
    }

    onMounted(() => {
      window.addEventListener('resize', onResize)
    });

    return {
      router,
      getTableComponents,
      collapsedMap,
      getExtendedColumns,
      getShortListColumns,
      emptySlot,
      showResult,
      orderForm,
      submitOrderForm,
      closeForm,
      isProcessing,
      successfullySubmitted,
      activeKeys,
      tableData,
      quotasLoaded,
      recalculateTotals,
      totalProductsToOrder,
      isMobile
    }
  }
}

</script>

<style lang="scss" scoped>
.form-group-row {
  display: flex;
  justify-content: space-between;
  column-gap: 10px;
  row-gap: 10px;

  @media (max-width: $mobile-breakpoint) {
    flex-direction: column;
    row-gap: 0;
  }
}

.input-form-item {
  min-width: 49%;
}

.password-radio-group,
.checkbox-group {
  display: flex;
  flex-direction: column;
  row-gap: 5px;
}

.password-field {
  margin: 10px;
}

:deep(.ant-input-focused) {
  border-color: var(--main-green);
}

.ant-input:hover,
.ant-input:focus {
  border-color: var(--main-green);;
}

.ant-input:focus,
.ant-select-focused .ant-select-selector {
  box-shadow: 0 0 0 2px var(--polar-green);
}

.ant-input-affix-wrapper:hover,
.ant-input-affix-wrapper-focused {
  border-color: var(--main-green);
}

.ant-input-affix-wrapper-focused {
  box-shadow: 0 0 0 2px var(--polar-green);
}

:deep(.ant-form-item-label) {
  padding: 0;
}

:deep(.ant-form-item) {
  margin-bottom: 12px;
}

.button-row {
  display: flex;
  column-gap: 10px;
  row-gap: 15px;
  justify-content: flex-end;

  @media (max-width: 768px) {
    flex-direction: column;
  }
}

.successful-text {
  margin: 16px 0 20px;
  text-align: center;
  font-size: 16px;
  font-weight: 500;
}

.successful-text p {
  margin-bottom: 0;
}

.successful-text span {
  font-size: 14px;
  color: var(--grey-text)
}

.successful-text .happy-smile,
.successful-text .frown-smile {
  font-size: 65px;
}

.successful-text .happy-smile {
  color: var(--main-green);
}

@media (max-width: $mobile-breakpoint) {
  .secondary-button {
    width: 100%;
  }
}

.free-quotas {
  color: var(--grey-text)
}

:deep(th) {
  padding: 5px 10px !important;
}

:deep(.ant-table-row td) {
  padding: 10px !important;
}

.order-list {
  display: flex;
  flex-direction: column;
  row-gap: 10px;
}

:deep(.ant-input-number-input),
:deep(.ant-input-number-input::placeholder) {
  text-align: right;
}

:deep(.ant-input-number-handler-wrap) {
  display: none;
}

@media (max-width: $mobile-breakpoint) {
  :deep(.ant-input-number) {
    width: 50px !important;
  }
}

:deep(.custom-collapse-expand-icon) {
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
  background: #fff;
  font-size: 12px;
  line-height: 1;
  cursor: pointer;
  transition: background 0.2s, border-color 0.2s, transform 0.2s;
  color: var(--main-font);
}

:deep(.custom-collapse-expand-icon--active) {
  transform: translateY(1px);
}
</style>